<template>
  
    <div class="container">
  <div class="row  align-items-center pt-5" >    
    <form   class="full-with-form" @submit.prevent="Issue()">                                         
                    <div class="col align-self-center">                                                                  
                        <div
                            v-for="(
                                role, index
                            ) in LoadAllTicekts"
                        >
                            
                                <input                                  
                                    class="form-check-input"
                                    :id="'user_permission' + role.id"
                                    :name="'user_permission' + role.id"
                                    type="checkbox"
                                    :value="role.id"
                                    :checked="isTicketChecked(role.id)"                      
                                    @change="toggleTicketSelection(role.id)"
                                />
                           
                                <label
                                    class="form-check-label"
                                    :for="
                                        'user_permission' + role.id
                                    "
                                    ><strong> {{ role.sku }}</strong> | {{ role.ticket_display_name }} </label
                                >                            
                        </div>
                    </div>                  
                          
                    <div class="col align-self-end">
                        <button
                            type="submit"
                            class="btn-small-width btn-invoice-background-refund-start"
                        >
                            Save
                        </button>
                    </div>                            
                </form>    
  </div>
</div>
</template>

<style scoped>

.btn-invoice-background-refund-start {
    background-color: #239b56;
    color: white;
}
</style>

<script>

const config = {
    headers: {       
        Accept: "application/json",       
    },
};
let formData = new FormData();

export default {

    created() {             
        this.getPreferTicket();   
    },
   

    data() {
        return {          
            SetTicket: [],
            LoadAllTicekts:[],                   
        };
    },

  

    methods: {              

        getPreferTicket() {
            axios
                .get("/cashier/get-cahier-prefer-ticket")
                .then((response) => {
                    try {                       
                        this.LoadAllTicekts = response.data.all;
                        this.SetTicket = JSON.parse(response.data.set.ticket);                                    
                    } catch (error) {
                        Toast.fire({
                        icon: "error",
                        title: "Before initiating the process to issue tickets, ensure this completion.",
                    });
                    }                  
                })
                .catch((error) => {
                    Toast.fire({
                        icon: "error",
                        title: "Something went wrong! ",
                    });
                });
        },

        isTicketChecked(ticketId) {
            if (this.SetTicket.length>0) {
                return this.SetTicket.includes(ticketId);
            }
                return false; // If SetTicket is empty, ticket is not checked
        },

        toggleTicketSelection(ticketId) {
         
            if (this.SetTicket.includes(ticketId)) {     
                const ticketArrays = JSON.parse(this.SetTicket); 
                const updated=ticketArrays.filter(id => id !== ticketId);
                this.SetTicket = JSON.stringify(updated);
            }else {

                if (this.SetTicket.length>0) { 
                    const ticketArraysS = JSON.parse(this.SetTicket);
                    ticketArraysS.push(ticketId);
                    this.SetTicket = JSON.stringify(ticketArraysS);            
                }else{           
                    this.SetTicket.push(ticketId);
                    this.SetTicket = JSON.stringify(this.SetTicket);
                }          
            }
        },

        Issue() {         
            formData.append("ticket", this.SetTicket);
            axios
                .post("/cashier/set-cahier-prefer-ticket", formData, config)
                .then((response) => {
                    Toast.fire({ icon: "success", title: "Setting updated" });
                })
                .catch((error) => {                    
                    if (error.response.status == 422) {
                        Toast.fire({
                        icon: "error",
                        title: "Something went wrong! 422 ",
                    });                     
                    }else {
                        Toast.fire({
                        icon: "error",
                        title: "Something went wrong! ".error,
                    });
                    }
                });            
        },
    },
};
</script>
